import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../../core/services/order.service';
import { IGetOrdersInquiryBody, IOrderInquiry, IOrderInquiryLbl } from '../../../core/models';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings } from '../../../core/common';
import { StatePersistingService } from '../../../core/services/state-persisting.service';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { CommonService } from '../../../core/services/common.service';
import { formatDate } from '@angular/common';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { forEach } from 'lodash';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-order-inquiry',
  templateUrl: './order-inquiry.component.html',
  styleUrls: ['./order-inquiry.component.scss']
})
export class OrderInquiryComponent implements OnInit {
  public gridData: IOrderInquiry[] = [];
  toDate: Date = new Date();
  fromDate: Date = new Date(this.toDate.getFullYear() - 1, this.toDate.getMonth(), this.toDate.getDay());//have kept to get data
  searchTextOrderInquiry: string = '';
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "jobNamelbl" },
      { controlName: "jobNumberlbl" },
      { controlName: "kdReflbl" },
      { controlName: "orderDatelbl" },
      { controlName: "orderTypeLbl" },
      { controlName: "orderNumberlbl" },

      { controlName: "polbl" },
      { controlName: "scheduleDatelbl" },
      { controlName: "shipFromlbl" },
      { controlName: "shipTolbl" },
      { controlName: "exportToExcelLbl" },
      { controlName: "exportToPDFLbl" },
    ];
    const componentName = "orderInquiry";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.orderlblText = response[response.length - 1];
      //console.log("aa", this.orderlblText);
      this.initializeGridHeader();
    }
  }
  public orderlblText: IOrderInquiryLbl = {
    jobNamelbl: '',
    jobNumberlbl: '',
    kdReflbl: '',
    orderDatelbl: '',
    orderTypeLbl: '',
    orderNumberlbl: '',
    polbl: '',
    scheduleDatelbl: '',
    shipFromlbl: '',
    shipTolbl: '',
    exportToExcelLbl: '',
    exportToPDFLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
  }

  //#endregion
  //#region label declaration
  public orderInquiryGridLbl = {
    orderNumberlbl: 'Order #',
    orderTypeLbl: 'Order Type',
    orderDatelbl: 'Order Date',
    scheduleDatelbl: 'Schedule Date',
    jobNamelbl: 'Job Name',
    jobNumberlbl: 'Job Number',
    kdReflbl: 'KD Ref#',
    polbl: 'PO #',
    // shipTolbl: 'Ship To',
    shipFromlbl: 'Ship From',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',

  };
  //#endregion
  //#region pagination, sorting,filtering for order grid

  public orderGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: [{
        field: "orderDateAsDate", operator: "gte", value: this.fromDate
      }, {
        field: "orderDateAsDate", operator: "lte", value: this.toDate
      }]
    },
  };

  public gridSettings: GridSettings = {
    state: this.orderGridstate,
    gridData: process(this.gridData, this.orderGridstate),
    columnsConfig: [{
      field: 'orderNumber',
      title: this.orderlblText.orderNumberlbl ? this.orderlblText.orderNumberlbl : this.orderInquiryGridLbl.orderNumberlbl,
      filterable: true

    }, {
      field: 'orderType',
      title: this.orderlblText.orderTypeLbl ? this.orderlblText.orderTypeLbl : this.orderInquiryGridLbl.orderTypeLbl,
      filterable: true
    }, {
      field: 'orderDateAsDate',
      title: this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderInquiryGridLbl.orderDatelbl,
      filter: 'date',
      format: '{0:d}',//not able to get from and to
      _width: 240,
      filterable: true
    }, {
      field: 'scheduleDateUIString',//'scheduleDateAsDate',
      title: this.orderlblText.scheduleDatelbl ? this.orderlblText.scheduleDatelbl : this.orderInquiryGridLbl.scheduleDatelbl,
      filter: 'date',
      format: '{0:d}',
      _width: 240,
      filterable: true
    }, {
      field: 'jobName',
      title: this.orderlblText.jobNamelbl ? this.orderlblText.jobNamelbl : this.orderInquiryGridLbl.jobNamelbl,
      filterable: true
    }, {
      field: 'jobNumber',
      title: this.orderlblText.jobNumberlbl ? this.orderlblText.jobNumberlbl : this.orderInquiryGridLbl.jobNumberlbl,
      filterable: true
    }, {
      field: 'poNumber',
      title: this.orderlblText.polbl ? this.orderlblText.polbl : this.orderInquiryGridLbl.polbl,
      filterable: true
      //},{                           //not there in KD 4.0
      //  field: 'shipTo',
      //  title: this.orderInquiryGridColumnLbl.shipTo,
      //  filterable: true
      //}, {
    },
    {
      field: 'shipFrom',
      title: this.orderlblText.shipFromlbl ? this.orderlblText.shipFromlbl : this.orderInquiryGridLbl.shipFromlbl,
      filterable: true
    },
    {
      field: 'kdReference',
      title: this.orderlblText.kdReflbl ? this.orderlblText.kdReflbl : this.orderInquiryGridLbl.kdReflbl,
      filterable: true
    }
    ]
  };

  loadingPDF: boolean;
  loadingExcel: boolean;

  constructor(private orderService: OrderService, private persistingService: StatePersistingService,
    private commonService: CommonService, private languageTranslationService: LanguageTranslationService) {
    const gridSettings: GridSettings = this.persistingService.get(this.orderService.readUserObject.userName + 'orderInquiryGridV2');

    if (gridSettings !== null) {
      this.gridSettings = this.mapGridSettings(gridSettings);
    }
  }
  orderInquiryGridData: GridDataResult;

  ngOnInit() {
    console.log(this.gridSettings);
    this.loadLanguageTranslationData();
    ////// console.log(this.orderGridstate);
    //////this.fromDate.setDate(this.fromDate.getDate() - 400);
    console.log(this.fromDate);
    console.log(this.toDate);
    this.loadOrderInquiryGrid(this.fromDate, this.toDate);
  }
  //#region Grid data binding
  orderLoading: boolean;
  public loadOrderInquiryGrid(fromDate: Date, toDate: Date): void {
    //call service here and fetch the grid data
    this.orderLoading = true;
    const body: IGetOrdersInquiryBody = {
      customerNumber: '',
      fromDate: fromDate,
      toDate: toDate
    }
    this.orderService.getOrders(body).subscribe((response: Array<IOrderInquiry>) => {
      //console.log(response);
      this.gridData = response.map((obj) => {
        obj.orderDateAsDate = obj.orderDateUIString ? new Date(obj.orderDateUIString) : null;
        obj.scheduleDateAsDate = obj.scheduleDateUIString == "Pending" ? null : new Date(obj.scheduleDateUIString);
        //obj.scheduleDateAsDate = obj.scheduleDateUIString && obj.statusId >= 526 ? new Date(obj.scheduleDateUIString) : null;
        //obj.scheduleDateUIString = obj.scheduleDateUIString && obj.statusId >= 526 ? obj.scheduleDateUIString : "Pending";
        return obj;
      },
        (error) => {
          //console.error('error caught in component-' + error);
          //throw error;
          this.orderLoading = false;
        }
      );
      this.loadOrderGridData();
      this.orderLoading = false;;

    })
  }
  //#endregion




  defaultSort = [{
    field: 'orderNumber',
    dir: 'desc'
  }];

  public loadOrderGridData(): void {
    if (this.gridSettings.state) {
      this.orderInquiryGridData = process(this.gridData, this.gridSettings.state);
    }
    else {
      this.orderInquiryGridData = process(this.gridData, this.orderGridstate);
    }
    //if (this.includePendingOrders) {
    //  let pendingOrders = this.gridData.filter(x => x.scheduleDate == "Pending");
    //  if (pendingOrders) {
    //    pendingOrders.forEach(el => {
    //      let index = this.orderInquiryGridData.data.findIndex(x => x.orderNumber == el.orderNumber);//add other filter as well
    //      if (index < 0) {
    //        this.orderInquiryGridData.data.push(el);
    //      }
    //    })
    //  }
    //}
    this.gridSettings.gridData = this.orderInquiryGridData;
  }

  public orderGridSortChange(sort): void {
    this.orderGridstate.sort = sort;
    this.loadOrderGridData();
  }

  public orderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderGridstate.skip = skip;
    this.orderGridstate.take;
    this.loadOrderGridData();
  }
  //when older date from fromDate and later date from toDate is selected
  //api call would be made or else filter would happen clientside
  public orderDataStateChange(state: DataStateChangeEvent): void {
    console.log(state);
    this.orderGridstate = state;
    this.gridSettings.state = this.orderGridstate;
    var newFromDate = new Date("01/01/2000");
    var newToDate = new Date("12/31/2099");
    const filters: any[] = state.filter.filters || [];
    var orderDatefilter = filters.filter(f => f.field == "orderDateAsDate")
    if (orderDatefilter) {
      this.searchTextOrderInquiry = '';
      var tempFromFilter = orderDatefilter.find(f => f.operator == "gte");
      if (tempFromFilter) {
        newFromDate = new Date(tempFromFilter.value);
      }
      var tempToFilter = orderDatefilter.find(f => f.operator == "lte");
      if (tempToFilter) {
        newToDate = new Date(tempToFilter.value);
      }
      //orderDatefilter.forEach(filter => {
      //  newFromDate = (filter.operator == "gte") ? new Date(filter.value) : newFromDate;
      //  newToDate = (filter.operator == "lte") ? new Date(filter.value) : newToDate;
      //});
      if ((newFromDate && newFromDate < this.fromDate) || (newToDate && newToDate > this.toDate)) {
        this.fromDate = newFromDate;
        this.toDate = newToDate;
        this.loadOrderInquiryGrid(newFromDate, newToDate);
      }
      else {
        this.loadOrderGridData();
      }
    }
    else {
      this.loadOrderGridData();
    }

    this.saveGrid();
  }

  //#endregion

  //storing the clicked row data in service
  orderDetail(val: string, orderType: string) {
    const rowData = this.orderInquiryGridData.data.find(r => r.orderNumber === val && r.orderType === orderType);
    this.orderService.setOrderInquiryData(rowData);
  }

  public onReorder(e: any): void {
    const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });

    this.saveGrid();
  }

  public saveGrid(): void {
    //reset skip
    this.gridSettings.state.skip = 0;
    const gridConfig = {
      columnsConfig: this.gridSettings.columnsConfig,
      state: this.gridSettings.state
    };
    this.persistingService.set(this.orderService.readUserObject.userName + 'orderInquiryGridV1', gridConfig);
  }

  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;
    let a = [];


    let minDate = state.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'gte');
    let maxDate = state.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'lte');
    if (!minDate || !maxDate) {
      minDate = this.orderGridstate.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'gte');
      maxDate = this.orderGridstate.filter.filters.find(x => x['field'] === 'orderDateAsDate' && x['operator'] === 'lte');
    }

    a.push(minDate);
    a.push(maxDate);
    gridSettings.state.filter.filters = a;


    const filters: any[] = state.filter.filters || [];
    filters.forEach(filter => {
      if (filter.field === 'orderDateAsDate' && filter.value) {
        filter.value = new Date(filter.value);
      }
      else {
        const index: number = filters.indexOf(filter);
        if (index !== -1) {
          filters.splice(index, 1); //dont want to save other filters
        }
      }

    });
    var orderDatefilter = filters.filter(f => f.field == "orderDateAsDate")
    if (orderDatefilter && orderDatefilter.length > 0) {
      var tempFromFilter = orderDatefilter.find(f => f.operator == "gte");
      if (tempFromFilter) {
        this.fromDate = new Date(tempFromFilter.value);
      }
      var tempToFilter = orderDatefilter.find(f => f.operator == "lte");
      if (tempToFilter) {
        this.toDate = new Date(tempToFilter.value);
      }
      //orderDatefilter.forEach(filter => {
      //  this.fromDate = (filter.operator == "gte") ? new Date(filter.value) : new Date("01/01/2000");
      //  this.toDate = (filter.operator == "lte") ? new Date(filter.value) : new Date("12/31/2099");
      //});
    }
    else {
      state.filter = this.orderGridstate.filter;
    }
    //---------------------------

    //reset skip
    state.skip = 0;
    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.gridData, state)
    };
  }


  async generatePDF() {
    this.loadingPDF = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: 'Order Inquiry', alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          text: this.orderlblText.customerNumberLbl ? this.orderlblText.customerNumberLbl : this.orderInquiryGridLbl.customerNumberLbl + " : " + this.orderService.readUserObject.customerNumber,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: this.orderlblText.customerNameLbl ? this.orderlblText.customerNameLbl : this.orderInquiryGridLbl.customerNameLbl + " : " + this.orderService.readUserObject.customerName,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: "Order Inquiry List",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            widths: [48, 40, 55, 65, 70, 65, 65,45],


            body: [
              [this.orderlblText.orderNumberlbl ? this.orderlblText.orderNumberlbl : this.orderInquiryGridLbl.orderNumberlbl,
              this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderInquiryGridLbl.orderDatelbl,
              this.orderlblText.scheduleDatelbl ? this.orderlblText.scheduleDatelbl : this.orderInquiryGridLbl.scheduleDatelbl,
              this.orderlblText.jobNamelbl ? this.orderlblText.jobNamelbl : this.orderInquiryGridLbl.jobNamelbl,
              this.orderlblText.jobNumberlbl ? this.orderlblText.jobNumberlbl : this.orderInquiryGridLbl.jobNumberlbl,
              this.orderlblText.polbl ? this.orderlblText.polbl : this.orderInquiryGridLbl.polbl,
              //this.orderInquiryGridColumnLbl.shipTo,
              this.orderlblText.shipFromlbl ? this.orderlblText.shipFromlbl : this.orderInquiryGridLbl.shipFromlbl,
              this.orderlblText.kdReflbl ? this.orderlblText.kdReflbl : this.orderInquiryGridLbl.kdReflbl],
              ...filterData.data.map(p =>
              ([
                p.orderNumber,
                p.orderDateUIString,
                p.scheduleDateUIString,
                p.jobName ? p.jobName : '',
                p.jobNumber,
                p.poNumber,
                //p.shipTo,
                p.shipFrom,
                p.kdReference
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('OrderInquiry.pdf');
    this.loadingPDF = false;
  }
  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.gridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Order Inquiry');
    const header = [this.orderlblText.orderNumberlbl ? this.orderlblText.orderNumberlbl : this.orderInquiryGridLbl.orderNumberlbl,
    this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderInquiryGridLbl.orderDatelbl,
    this.orderlblText.scheduleDatelbl ? this.orderlblText.scheduleDatelbl : this.orderInquiryGridLbl.scheduleDatelbl,
    this.orderlblText.jobNamelbl ? this.orderlblText.jobNamelbl : this.orderInquiryGridLbl.jobNamelbl,
    this.orderlblText.jobNumberlbl ? this.orderlblText.jobNumberlbl : this.orderInquiryGridLbl.jobNumberlbl,
    this.orderlblText.polbl ? this.orderlblText.polbl : this.orderInquiryGridLbl.polbl,
    //this.orderInquiryGridColumnLbl.shipTo,
    this.orderlblText.shipFromlbl ? this.orderlblText.shipFromlbl : this.orderInquiryGridLbl.shipFromlbl,
    this.orderlblText.kdReflbl ? this.orderlblText.kdReflbl : this.orderInquiryGridLbl.kdReflbl];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let ClientIdRow = worksheet.addRow([this.orderlblText.customerNumberLbl ? this.orderlblText.customerNumberLbl : this.orderInquiryGridLbl.customerNumberLbl + ":" + this.orderService.readUserObject.customerNumber + '']);
    ClientIdRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    let ClientNameRow = worksheet.addRow([this.orderlblText.customerNameLbl ? this.orderlblText.customerNameLbl : this.orderInquiryGridLbl.customerNameLbl + ":" + this.orderService.readUserObject.customerName + '']);
    ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow(['Order Inquiry']);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
    ([
      p.orderNumber,
      p.orderDateUIString,
      p.scheduleDateUIString,
      p.jobName ? p.jobName : '',
      p.jobNumber,
      p.poNumber,
      // p.shipTo,
      p.shipFrom,
      p.kdReference
    ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'OrderInquiry.xlsx');
    })
    this.loadingExcel = false;
  }


  initializeGridHeader() {

    this.gridSettings.columnsConfig.forEach((el) => {
      if (el.field == 'orderNumber') {
        el.title = this.orderlblText.orderNumberlbl ? this.orderlblText.orderNumberlbl : this.orderInquiryGridLbl.orderNumberlbl;
      }


      if (el.field == 'orderType') {
        el.title = this.orderlblText.orderTypeLbl ? this.orderlblText.orderTypeLbl : this.orderInquiryGridLbl.orderTypeLbl;
      }
      if (el.field == 'orderDateAsDate') {
        el.title = this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderInquiryGridLbl.orderDatelbl;

      }
      if (el.field == 'scheduleDateUIString') {
        el.title = this.orderlblText.scheduleDatelbl ? this.orderlblText.scheduleDatelbl : this.orderInquiryGridLbl.scheduleDatelbl;

      }
      if (el.field == 'jobName') {
        el.title = this.orderlblText.jobNamelbl ? this.orderlblText.jobNamelbl : this.orderInquiryGridLbl.jobNamelbl;
      }
      if (el.field == 'jobNumber') {
        el.title = this.orderlblText.jobNumberlbl ? this.orderlblText.jobNumberlbl : this.orderInquiryGridLbl.jobNumberlbl;
      }
      if (el.field == 'poNumber') {
        el.title = this.orderlblText.polbl ? this.orderlblText.polbl : this.orderInquiryGridLbl.polbl;

      }
      if (el.field == 'shipFrom') {
        el.title = this.orderlblText.shipFromlbl ? this.orderlblText.shipFromlbl : this.orderInquiryGridLbl.shipFromlbl;
      }
      if (el.field == 'kdReference') {
        el.title = this.orderlblText.kdReflbl ? this.orderlblText.kdReflbl : this.orderInquiryGridLbl.kdReflbl;
      }
    });
  }


  public onFilterOrderInquiry(inputValue: string): void {
    if (this.gridData.length > 0) {
      var primaryFilter = this.gridSettings.state.filter;
      var primaryFilteredData = process(this.gridData, {
        filter: primaryFilter
      });
      this.orderInquiryGridData = process(primaryFilteredData.data, {
        filter: {
          logic: "or",
          filters: [
            {
              field: "orderNumber",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "orderType",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "orderDateUIString",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "scheduleDateUIString",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "jobName",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "jobNumber",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "poNumber",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "shipFrom",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "kdReference",
              operator: "contains",
              value: inputValue,
            }
          ],
        },
      });
      if (!inputValue) {
        this.orderGridstate.skip = 0;
        this.orderGridstate.take = 10;
        this.loadOrderGridData();
      }
    }

  }


  includePendingOrders: boolean = true;
  public setIncludePendingOrderFlag(value: boolean) {
    this.includePendingOrders = value;
  }


  pnc() {
    this.orderService.redirectToPNC();
  }
}
